import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useConfirmResult = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Failed to confirm result");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ ids }) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/common/status/bulk`,
        {
          ids: ids,
          status: "CONFIRMED",
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Results confirmed successfully!");
      queryClient.invalidateQueries({ queryKey: ["staffLaboratoryResults"] });
      queryClient.invalidateQueries({
        queryKey: ["unmatchedStaffLaboratoryResults"],
      });
      queryClient.invalidateQueries({ queryKey: ["staffRadiologyResults"] });
      queryClient.invalidateQueries({
        queryKey: ["unmatchedStaffRadiologyResults"],
      });
      queryClient.invalidateQueries({ queryKey: ["staffCommonResults"] });
      queryClient.invalidateQueries({
        queryKey: ["unmatchedStaffCommonResults"],
      });
    },
    onError: handleNetworkError,
    // Show only this specific toast — opt out of the global MutationCache handler.
    meta: { skipGlobalError: true },
  });
};
